<ef-loading-container
    [observables]="[jobs$, customers$]"
></ef-loading-container>
<ef-process-detail [process]="process$ | async"></ef-process-detail>

<ef-contract-structure-presenters
    [jobs]="jobs$ | async"
    [jobListStatus]="jobListStatus$ | async"
    [customers]="customers$ | async"
    [contractTypes]="contractTypes$ | async"
    (LoadJobListStatus)="onLoadJobListStatus($event)"
    (LoadCustomerJobs)="onLoadCustomerJobs($event)"
    [process]="process$ | async"
    [errors]="errors$ | async"
    [selectedError]="selectedError$ | async"
    (ShowError)="OnShowError($event)"
>
</ef-contract-structure-presenters>
